import { render, staticRenderFns } from "./EndorsementList.vue?vue&type=template&id=eb1e0178"
import script from "./EndorsementList.vue?vue&type=script&lang=js"
export * from "./EndorsementList.vue?vue&type=script&lang=js"
import style0 from "./EndorsementList.vue?vue&type=style&index=0&id=eb1e0178&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports